import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-476f35ad"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Channel" }
const _hoisted_2 = { class: "viewport" }

import { onMounted } from 'vue'
import { footmarkShopList, footmarkGoodsList } from '@/assets/js/channel/type'
import { t } from '@/plugins/i18n'
import Category from '@/components/bussiness/Category/Category.vue'
import Carousel from '@/components/common/Carousel.vue'
import LikeGoods from '@/components/common/LikeGoods.vue'
import FootmarkShop from './components/FootmarkShop.vue'
import FootmarkGoods from './components/FootmarkGoods.vue'
import ConfigRecommendShop from './components/ConfigRecommendShop.vue'
import RecommendShop from '@/components/common/RecommendShop.vue'
import ConfigRecommendGoods from './components/ConfigRecommendGoods.vue'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

onMounted(() => {
  store.dispatch('guide/openGuide', { guideKey: 'guide-channel-all' })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Category),
    _createVNode(Carousel, { type: "0" }),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(footmarkShopList), (item) => {
        return (_openBlock(), _createBlock(FootmarkShop, {
          key: item.type,
          context: item
        }, null, 8, ["context"]))
      }), 128)),
      _createVNode(ConfigRecommendShop),
      _createVNode(RecommendShop, {
        title: _unref(t)('推荐店铺（含档口）')
      }, null, 8, ["title"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(footmarkGoodsList), (item) => {
        return (_openBlock(), _createBlock(FootmarkGoods, {
          key: item.type,
          context: item
        }, null, 8, ["context"]))
      }), 128)),
      _createVNode(ConfigRecommendGoods),
      _createVNode(LikeGoods)
    ])
  ]))
}
}

})